// extracted by mini-css-extract-plugin
module.exports = {"l-main":"_l-main_l-main__QXaCM"};